export default __webpack_public_path__ + "static/media/16.c82f2369.png";